module.exports = __webpack_public_path__ + "static/media/store.cad1de39.png";